///
/// EarthBrowser Admin Dashboard - Entry Point
///
/// Created: 2025-11-27
/// Copyright (c) 2025 Geodata Labs
///

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { HelmetProvider } from 'react-helmet-async'
import { ThemeProvider } from '@/app/ThemeProvider'
import { store } from '@/redux/store'
import App from '@/App'
import '@/styles/globals.css'

// Dev-only debug hook (mirrors window.__ebDebug in the main app) so the
// store can be inspected and driven from the browser console during testing
if (import.meta.env.DEV) {
  const debugWindow = window as unknown as Record<string, unknown>
  debugWindow.__adminDebug = {
    getState: store.getState,
    dispatch: store.dispatch,
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={store}>
      <HelmetProvider>
        <ThemeProvider attribute='class' defaultTheme='dark' disableTransitionOnChange>
          <App />
        </ThemeProvider>
      </HelmetProvider>
    </Provider>
  </StrictMode>
)

